import Image from "next/image"
import { AutoBreadcrumb } from "@/components/auto-breadcrumb"
import { BackButton } from "@/components/ui/back-button"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { env } from "@/lib/env"
import { cn } from "@/lib/utils"

export function NavHeader({
  position,
  variant,
}: {
  position: "left" | "right"
  variant: "default" | "inset"
}) {
  const currentEvent = {
    description: {
      long: "GRS",
    },
  }
  const environment = env.NEXT_PUBLIC_ENV || "DEV_FALLBACK"

  const envColor = () => {
    switch (environment) {
      case "production":
        return "text-green-600"
      case "development":
        return "text-red-500"
      case "test":
        return "text-blue-500"
      case "pre":
        return "text-yellow-500"
      default:
        return "text-primary-foreground"
    }
  }

  return (
    <header
      className={cn(
        "sticky top-0 z-10 flex min-h-16 shrink-0 items-center gap-2 border-b bg-gradient-to-r from-sidebar-header-gradient-from to-sidebar-header-gradient-to px-4 transition-[width,height] ease-linear",
        variant === "inset" && "rounded-t-2xl ",
      )}
    >
      <div
        className={cn(
          "flex flex-col w-full px-4 py-2 items-center justify-between",
          position === "right" ? "md:flex-row-reverse" : "md:flex-row",
        )}
      >
        <div className="flex w-full items-center justify-between md:w-auto">
          <div
            className={cn("flex items-center gap-2", position === "right" && "flex-row-reverse")}
          >
            <SidebarTrigger className="-ml-1 text-primary-foreground" />
            <Separator className="mr-2 h-4 w-px text-primary-foreground" orientation="vertical" />
            <BackButton />
            <Separator className="mx-2 h-4 w-px text-primary-foreground" orientation="vertical" />
            <AutoBreadcrumb />
          </div>
          <div className="block md:hidden">
            <Image
              alt="Logo"
              className="h-8 max-w-[120px] object-contain"
              height={32}
              src="/logo-client.png"
              width={120}
            />
          </div>
        </div>

        <div className="mt-2 flex flex-col items-center justify-center gap-1 sm:mt-0">
          {/* Texto animado del evento - simplificado */}
          <div className="text-center text-sm font-bold text-primary-foreground sm:text-base md:text-lg lg:text-xl xl:text-2xl">
            {currentEvent.description.long}
          </div>
          <div className="flex items-center gap-2">
            {/* <Image
              src="/logo-environment.png"
              alt="logo"
              className="h-8 w-auto object-contain"
              width={32}
              height={32}
            /> */}
            <p
              className={cn(`hidden text-center font-bold text-primary-foreground md:block`, envColor())}
            >
              {environment !== "production" ? environment : ""}
            </p>
          </div>
        </div>

        <div className="hidden md:block">
          <Image
            alt="CIS Logo"
            className="h-12 max-w-[150px] object-contain md:h-10 lg:h-[50px]"
            height={50}
            src="/logo.png"
            width={150}
          />
        </div>
      </div>
    </header>
  )
}
